import { jsx as _jsx } from "react/jsx-runtime";
import { linkClasses } from '@mui/material';
import { forwardRef } from 'react';
import { LinkStyled } from './Link.styled';
const Link = forwardRef((props, ref) => {
    return _jsx(LinkStyled, { ...props, ref: ref });
});
export { Link, linkClasses };
